var _circle, _path, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcon18(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 34,
    viewBox: "0 0 35 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 17.5002,
    cy: 16.8395,
    r: 15.4167,
    fill: "white",
    stroke: "url(#paint0_linear_1897_44549)",
    strokeWidth: 2.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.1005 12.1725H11.7005V21.5059H9.86049V14.1192L8.10049 14.6125L7.64715 13.0392L10.1005 12.1725ZM18.4967 16.6525C19.359 17.1681 19.7901 17.9192 19.7901 18.9059C19.7901 19.7681 19.4879 20.4481 18.8834 20.9459C18.2879 21.4436 17.4745 21.6925 16.4434 21.6925C15.4034 21.6925 14.5856 21.4436 13.9901 20.9459C13.3945 20.4481 13.0967 19.7681 13.0967 18.9059C13.0967 17.9192 13.5234 17.1681 14.3767 16.6525C13.7279 16.1814 13.4034 15.537 13.4034 14.7192C13.4034 13.857 13.6923 13.1859 14.2701 12.7059C14.8567 12.2259 15.5812 11.9859 16.4434 11.9859C17.3056 11.9859 18.0256 12.2259 18.6034 12.7059C19.1812 13.1859 19.4701 13.857 19.4701 14.7192C19.4701 15.5459 19.1456 16.1903 18.4967 16.6525ZM17.3101 14.0125C17.0879 13.817 16.799 13.7192 16.4434 13.7192C16.0879 13.7192 15.799 13.817 15.5767 14.0125C15.3545 14.2081 15.2434 14.4747 15.2434 14.8125C15.2434 15.1503 15.3545 15.4214 15.5767 15.6259C15.799 15.8214 16.0879 15.9192 16.4434 15.9192C16.799 15.9192 17.0879 15.8214 17.3101 15.6259C17.5323 15.4214 17.6434 15.1503 17.6434 14.8125C17.6434 14.4747 17.5323 14.2081 17.3101 14.0125ZM15.3367 19.6259C15.6212 19.8481 15.9901 19.9592 16.4434 19.9592C16.8967 19.9592 17.2612 19.8481 17.5367 19.6259C17.8212 19.3947 17.9634 19.0747 17.9634 18.6659C17.9634 18.2659 17.8212 17.9547 17.5367 17.7325C17.2612 17.5014 16.8967 17.3859 16.4434 17.3859C15.9901 17.3859 15.6212 17.5014 15.3367 17.7325C15.0612 17.9547 14.9234 18.2659 14.9234 18.6659C14.9234 19.0747 15.0612 19.3947 15.3367 19.6259ZM26.9415 16.0259V17.6392H24.7415V19.8392H23.1282V17.6392H20.9415V16.0259H23.1282V13.8392H24.7415V16.0259H26.9415Z",
    fill: "url(#paint1_linear_1897_44549)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1897_44549",
    x1: 17.5002,
    y1: 0.172852,
    x2: 17.5002,
    y2: 33.5062,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F79F2D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF4D4D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1897_44549",
    x1: 18.0005,
    y1: 8.50586,
    x2: 18.0005,
    y2: 24.5059,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F79F2D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF4D4D"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon18);
export default __webpack_public_path__ + "static/media/icon18.e659baaeb2733ac14b97771a99360968.svg";
export { ForwardRef as ReactComponent };